import { Injectable } from '@angular/core';

import { Subject } from 'rxjs';

import { SemantriaUser } from 'app/providers/semantria-api/semantria-users.service';
import { EnableClassTelemetry } from 'app/services/otel.service';

@EnableClassTelemetry()
@Injectable({
  providedIn: 'root',
})
export class UserListService {
  private userListChanged$ = new Subject<SemantriaUser[]>();
  userListChanged = this.userListChanged$.asObservable();

  private selectedUserChanged$ = new Subject<SemantriaUser>();
  selectedUserChanged = this.selectedUserChanged$.asObservable();

  private userDeleted$ = new Subject<SemantriaUser>();
  userDeleted = this.userDeleted$.asObservable();

  private refreshSelectedUser$ = new Subject<void>();
  refreshSelectedUser = this.refreshSelectedUser$.asObservable();

  private refreshAllUsers$ = new Subject<void>();
  refreshAllUsers = this.refreshAllUsers$.asObservable();

  constructor() {}

  usersLoaded(users: SemantriaUser[]) {
    this.userListChanged$.next(users);
  }

  userSelected(user: SemantriaUser) {
    this.selectedUserChanged$.next(user);
  }

  afterUserDeleted(user: SemantriaUser) {
    this.userDeleted$.next(user);
  }

  selectedUserNeedsRefresh() {
    this.refreshSelectedUser$.next();
  }

  allUsersNeedRefresh() {
    this.refreshAllUsers$.next();
  }
}
